// @flow

import { observer } from "mobx-react";
import React from "react";

import Notification from "app/models/Notification";

import NotificationComponent from "app/components/Notification/Notification";

import "./Notifications.scss";

type Props = {
    items: Notification[],
    onRemove: Function
};

@observer
export default class Notifications extends React.Component<Props> {
    render() {
        return (
            <div className="Notifications">
                {this.props.items.map((notification: Notification) => (
                    <NotificationComponent
                        key={notification.key}
                        notification={notification}
                        onRemove={this.props.onRemove}
                    />
                ))}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Notifications/Notifications.js